<template>
  <van-popup
    class="login-popup-wrapper"
    v-model:show="visible"
    duration="0.1"
    teleport="body"
    round
    :close-on-click-overlay="false"
  >
    <div class="login-container" :class="theme">
      <div class="login-header" v-if="showPopupHeader">
        <popup-header />
        <div class="close-icon flex-center" @click="closeDialog">
          <van-icon name="cross" />
        </div>
      </div>
      <div class="login-main">
        <gTab :navList="navList" :loginDialogType="type" @changeTabType="changeTabType" />
        <div class="tab-content">
          <Login :visible="visible" :login-type="loginWay" @success="onSuccess" v-if="type == 1" />
          <Register
            :visible="visible"
            :register-type="registerWay"
            :actions-bar-height="actionsBarHeight"
            @success="onRegisterSuccess"
            v-if="type == 2"
          />
          <actions-bar
            ref="actionsBarRef"
            :login-way="loginWay"
            :register-way="registerWay"
            :type="type"
            @checkAuthWay="checkAuthWay"
          />
        </div>
      </div>
      <div class="close-icon flex-center" @click="closeDialog" v-if="showBottomCloseBtn">
        <SvgIcon iconName="close" :width="80" />
      </div>
    </div>
  </van-popup>
  <recover-password />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, onMounted, onUnmounted, ref, watch } from 'vue';
import { storeToRefs, useAppStore, useModalStore, useTenantStore } from '@star/stores';
import { emitter, EventEnum, LoginData } from '@star/utils';
import { useRouter } from 'vue-router';
import gTab from '@/components/auth/gTab/index.vue';
import ActionsBar from '@/components/auth/ActionsBar/index.vue';
import Login from '@/components/auth/Login/index.vue';
import Register from '@/components/auth/Register/index.vue';
import { useElementSize } from '@vueuse/core';
import { ModalTypeEnum, ThemeEnum } from '@star/constants';

const PopupHeader = defineAsyncComponent(() => import('@/components/auth/PopupHeader/index.vue'));
const RecoverPassword = defineAsyncComponent(() => import('@/components/auth/Login/RecoverPassword.vue'));

const tenantState = useTenantStore();
const modalStore = useModalStore();
const { loginMode, registerMode, isReqPlatformData } = storeToRefs(tenantState);
const { theme } = storeToRefs(useAppStore());

const router = useRouter();

const actionsBarRef = ref<any>(null);
const visible = ref<boolean>(false);
const type = ref<number>(0);
const redirect = ref<string>();
const loginWay = ref<string>('');
const registerWay = ref<string>('');

const { height: actionsBarHeight } = useElementSize(actionsBarRef);

const navList = ref<any[]>([
  { title: '登录', type: 1 },
  { title: '注册', type: 2 },
]);

const showPopupHeader = computed(() => {
  return [ThemeEnum.DARK].includes(theme.value);
});

const showBottomCloseBtn = computed(() => {
  return ![ThemeEnum.DARK].includes(theme.value);
});

const init = async () => {
  // await getReqContactConfig();
  loginWay.value = loginMode.value;
  registerWay.value = registerMode.value;
};

const checkAuthWay = (data: any) => {
  console.log(data);
  if (data?.type === 1) {
    loginWay.value = data?.value;
  } else if (data?.type === 2) {
    registerWay.value = data?.value;
  }
};

const closeDialog = () => {
  visible.value = false;
  redirect.value = undefined;
  setTimeout(() => {
    type.value = 0;
    modalStore.hideModal(ModalTypeEnum.LOGIN_REGISTER_MODAL);
  }, 300);
};

const changeTabType = (value: number) => {
  type.value = value;
};

const onSuccess = () => {
  modalStore.setEveryLoginModalStatus();
  if (redirect.value) {
    router.push({ path: redirect.value }).then(() => {
      emitter.emit(EventEnum.PAGE_API_RELOAD);
    });
  } else {
    isReqPlatformData.value = false;
    emitter.emit(EventEnum.PAGE_API_RELOAD);
  }
  closeDialog();
};

const onRegisterSuccess = () => {
  onSuccess();
};

const getReqContactConfig = async () => {
  await tenantState
    .reqContactConfig()
    .then(res => {})
    .finally(() => {});
};

emitter.on(EventEnum.LOGIN, (data: LoginData) => {
  // console.log(EventEnum.LOGIN, data);
  type.value = data?.type ?? 0;
  redirect.value = data?.redirect;
});

watch(
  () => type.value,
  value => {
    visible.value = !!value;
  },
  {
    immediate: true,
  }
);

onMounted(() => {
  init();
});

onUnmounted(() => {});
</script>

<style scoped lang="less">
.login-popup-wrapper {
  padding: 0;
  overflow-y: visible;
}

.login-container {
  width: 90vw;
  border-radius: 50px;

  .close-icon {
    width: 100px;
    height: 100px;
    position: absolute;
    bottom: -130px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .login-header {
    position: relative;

    .close-icon {
      bottom: auto;
      left: auto;
      top: 18px;
      right: 18px;

      .van-icon {
        font-size: 54px;
        color: var(--theme-icon-color-2);
      }
    }
  }

  &.dark {
    background: #202330;

    .login-main {
      background: var(--van-popup-background);
      border-radius: var(--van-popup-round-radius);
      overflow: hidden;
    }
  }
}
</style>
